<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <div class="container is-fluid">
      <h1 class="title is-5">{{ $t('routes.editEmployee') }}</h1>
      <div class="form-container">
        <EmployeeForm v-if="relations.departments" :data="instance" @save="save"></EmployeeForm>
      </div>
    </div>
  </DashboardLayout>
</template>

<script>
  import DashboardLayout from '@/components/DashboardLayout'
  import EmployeeForm from "@/components/EmployeeForm"
  import {mapState} from 'vuex'

  export default {
    components: {
      EmployeeForm,
      DashboardLayout,
    },
    methods: {
      save(payload) {
        this.$store.dispatch('Moderator/update', {actionType: 'employees', payload}).then(() =>
          this.$router.push({ name: 'employees'}))
      }
    },
    mounted() {
      this.$store.dispatch('Moderator/getRelations', {actionType: 'employees', id: this.$route.params.id})
    },
    computed: {
      ...mapState('Moderator', ['relations']),
      breadcrumbs() {
        return [
          {name: 'employees', path: 'employees'},
          {name: 'editEmployee'}
        ]
      },
      instance() {
        return this.relations.instance ? {
          ...this.relations.instance,
          birthday: this.relations.instance.birthday ? new Date(this.relations.instance.birthday) : null,
          hired_date: this.relations.instance.hired_date ? new Date(this.relations.instance.hired_date) : null,
          dismissal_date: this.relations.instance.dismissal_date ? new Date(this.relations.instance.dismissal_date) : null
        } : {}
      }
    }
  }
</script>
